import { useEffect, useState } from "react";

// styles 
import './CreateProject.css'
import { externalStore } from "../../store/Store";
import DropDown from "../../formComponents/DropDown";

export default function FscAreaDropdown({setFscArea, id}) {
    // global
    const fscArea = externalStore(exData => exData.fscArea)
    // local
    const [fscDD, setFscDD] = useState({})
    const [error, setError] = useState(null)

    useEffect(() => {
        let results = []
        setError(null)
        if (fscArea && fscArea.response && fscArea.response.facets) {
            fscArea.response.facets.forEach(area => {
                results.push({value: area.id, label: area.name})
            })
        } else {
            setError("Could not retrieve the FSC Area")
        }
        setFscDD(results)
    }, [fscArea])
    
    return (
        <DropDown 
            name={'fsc_area'}
            title={"FSC Area"}
            options={fscDD}
            onChange={setFscArea}
            maxMenuHeight={200}
            errorMsg={error}
            value={id && fscDD.filter(f => f.value === id)}
        />
    )
}
